module.exports = __webpack_public_path__ + "static/img/case_detail_15_2.fb03d59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_15_2.png
// module id = OYeD
// module chunks = 34